// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"31e92aab","297":"2cdff7fc","418":"ed735296","568":"9399565b","631":"421a554d","727":"d0353492","750":"35f65942","774":"50eb1c42","908":"a0c5aba9"}[chunkId] + ".chunk.js";
};